import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { Booking } from 'anchor-shared/lib/model/entity/booking';
import { CrewMember } from 'anchor-shared/lib/model/entity/crewMember';

@Injectable()
export class CrewMemberDAO extends BaseDAO<CrewMember> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.CREWMEMBER);
  }

  public retrieveAllActive(): Observable<CrewMember[]> {
    const url: string = this.apiHelper.getServiceName() + this.getResource();
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<CrewMember[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public createCrewMember(data: any): Observable<any> {
    const url: string = this.apiHelper.getServiceName() + this.getResource();
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<Booking>(url, method, null, data, headers);
  }

  public addCrewMemberToUser(
    crewData: Partial<CrewMember>,
  ): Observable<CrewMember> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/addNewCrewMemberToUser';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<CrewMember>(
      url,
      method,
      null,
      crewData,
      headers,
    );
  }

  findCrewById(crewId: number): Observable<any> {
    // if a crewId isnt given it will be set to number 0 to allow the admin to add a non-crewmember to payouts
    if (!crewId) {
      crewId = 0;
    }
    const url =
      this.apiHelper.getServiceName() + this.getResource() + '/' + crewId;
    const body = {};
    const method = 'GET';
    const httpHeader: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, method, null, body, httpHeader);
  }

  findCrewByUserId(userId: number): Observable<CrewMember> {
    const url =
      this.apiHelper.getServiceName() + this.getResource() + '/user/' + userId;
    const body = {};
    const method = 'GET';
    const httpHeader: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, method, null, body, httpHeader);
  }

  deleteById(crewId: number): Observable<any> {
    const url =
      this.apiHelper.getServiceName() + this.getResource() + '/' + crewId;
    const body = {};
    const method = 'DELETE';
    const httpHeader: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, method, null, body, httpHeader);
  }
}
